// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"uB","zenCrossSiteLabel":"vB","vrsnlCrossSiteLabel":"wB"};